import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Channel } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useRevealChannel = (
  projectId: string,
  channelId: string,
  options: Omit<UseMutationOptions<Channel, ErrorResponse, void, unknown>, "mutationFn"> = {}
) => {
  return useMutation<Channel, ErrorResponse, void, unknown>({
    mutationFn: async (): Promise<Channel> => {
      const response = await api.get<Channel>(`/projects/${projectId}/channels/${channelId}/reveal`);
      return camelize(response.data);
    },
    ...options
  });
};
